export type ApiError = {
  type: string;
  title: string;
  status: number;
  detail?: string;
  errors?: Record<string, string[]>;
};

export class ApiException extends Error {
  constructor(public payload: ApiError) {
    super(payload.detail ?? payload.title);
    this.name = 'ApiException';
  }
}

const BASE = '/api/v1';

async function request<T>(path: string, init: RequestInit & { json?: unknown } = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.json !== undefined) {
    headers.set('content-type', 'application/json');
    init.body = JSON.stringify(init.json);
  }
  const res = await fetch(`${BASE}${path}`, {
    ...init,
    headers,
    credentials: 'include',
  });
  if (res.status === 204) return undefined as T;
  const text = await res.text();
  const data = text ? JSON.parse(text) : null;
  if (!res.ok) {
    throw new ApiException(data as ApiError);
  }
  return data as T;
}

export const api = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, body?: unknown) => request<T>(path, { method: 'POST', json: body }),
  patch: <T>(path: string, body?: unknown) => request<T>(path, { method: 'PATCH', json: body }),
  del: <T>(path: string) => request<T>(path, { method: 'DELETE' }),
};
